import { z } from 'zod';

export type BaseEvent = z.output<typeof baseEventSchema>;
export type BaseEventDTO = z.input<typeof baseEventSchema>;

export const baseEventSchema = z.object({
  playerId: z.uuid(),
  startX: z.number(),
  startY: z.number(),
  timestamp: z.string(),
  type: z.string(),
});
